












































































































































import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import { renderMedicineHtml } from "./medicineTextConverter";

interface ProductView {
  product_name: string;
  major_heading: string;
  unit: string;
  generic_name: string;
  category: string;
  indications: string;
  dosage: string;
  features: string;
}

interface MedicineItemView {
  yj_code: string;
  name: string;
  is_generic: boolean;
  unit: string;
  generic_name: string;
  category: string;
  indications: string;
  dosage: string;
  features: string;
  photo_file_name: string;
  sub_photo_file_names: string[];
  products: ProductView[];
}

@Component
export default class MedicineSearchDialog extends Mixins(AxiosMixin) {
  @Prop({ default: false }) value!: boolean;

  private readonly displayLimit = 50;

  private internalValue = false;
  private searchQuery = "";
  private hasSearched = false;
  private searchResults: MedicineItemView[] = [];
  private debounceTimer: ReturnType<typeof setTimeout> | null = null;
  private cancelSearch: (() => void) | null = null;

  get displayedResults(): MedicineItemView[] {
    return this.searchResults.slice(0, this.displayLimit);
  }

  @Watch("value")
  private onValueChanged(val: boolean) {
    this.internalValue = val;
    if (val) {
      this.searchQuery = "";
      this.hasSearched = false;
      this.searchResults = [];
    }
  }

  @Watch("searchQuery")
  private onSearchQueryChanged() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.performSearch();
    }, 300);
  }

  @Emit("input")
  private emitInput(val: boolean) {
    return val;
  }

  @Emit("select")
  private selectItem(item: MedicineItemView) {
    return item;
  }

  private renderMedicineHtml(text: string): string {
    return renderMedicineHtml(text);
  }

  private close() {
    if (this.cancelSearch) {
      this.cancelSearch();
      this.cancelSearch = null;
    }
    this.internalValue = false;
    this.emitInput(false);
  }

  private performSearch() {
    if (!this.searchQuery.trim()) {
      this.hasSearched = false;
      this.searchResults = [];
      return;
    }

    // 前のリクエストをキャンセルしてから新しいリクエストを発行
    if (this.cancelSearch) this.cancelSearch();
    this.cancelSearch = this.postJsonCheckCancelable(
      window.base_url + "/api/patient/medicine/items/get",
      { medicine_name: this.searchQuery.trim() },
      res => {
        this.hasSearched = true;
        this.searchResults = res.data.medicine_items || [];
      }
    );
  }
}
